export enum AgentDocumentType {
  CONSENT = 'CONSENT',
  DOCUMENT = 'DOCUMENT',
  ACT = 'ACT',
  STANDARD = 'STANDARD',
}

export enum AgentClaimType {
  PROFILE_UPDATE = 'PROFILE_UPDATE',
  CONTRACT_TERMINATION = 'CONTRACT_TERMINATION',
  VAT_CHANGE = 'VAT_CHANGE',
  OTHER = 'OTHER',
  POLICYHOLDER_CHOOSE = 'POLICYHOLDER_CHOOSE',
}

export enum Gender {
  MALE = '1',
  FEMALE = '2',
}

export enum AgentEmploymentType {
  RGS = 'RGS',
  EXTERNAL = 'EXTERNAL',
}

export enum AgentType {
  FL = 'FL',
  IP = 'IP',
  LE = 'LE',
}
